import axios from 'axios';
import moment from 'moment';
import { toast, Slide } from 'react-toastify'
import { X, Check, Trash, Users ,RefreshCw ,PhoneCall ,FastForward ,ThumbsUp ,ThumbsDown ,PauseCircle ,UserCheck ,Star, Link, PhoneIncoming } from 'react-feather'
import * as ReactFeatherIcon from 'react-feather'
import * as XLSX from 'xlsx';
import { Fragment } from 'react';
import themeConfig from '@configs/themeConfig'
// ** Custom Components
import Avatar from '@components/avatar'
import whatsappWhite from '@src/assets/images/icons/whatsappWhite.svg';
import whatsappGreen from '@src/assets/images/icons/whatsappGreen.svg';
import whatsappPrimary from '@src/assets/images/icons/whatsappPrimary.svg';
import dotenv from "dotenv";
dotenv.config();
import Papa from 'papaparse';
import queryString from 'query-string';
import UAParser from 'ua-parser-js';

const {
  REACT_APP_UI_DOMAIN
} = process.env;

/*
* custome function to set leadCount - HT
*/
export const setLeadCountOnSideBar = () => {
  let leadBoardLeadCount = localStorage.getItem('leadBoardLeadCount') ? parseInt(localStorage.getItem('leadBoardLeadCount')) : 0;
  setTimeout(() => {
    if (leadBoardLeadCount && typeof leadBoardLeadCount == 'number' && leadBoardLeadCount > 0) {
      if (document.querySelector('a[href="/leadBoard"]') && document.querySelector('a[href="/leadBoard"]').querySelector('.badge')) {
        document.querySelector('a[href="/leadBoard"]').querySelector('.badge').textContent = leadBoardLeadCount || 0;
      }
    }
  }, 1000);
}
export const setPlanNameOnSideBar = () => {
  let planName = localStorage.getItem('activePlanName') || 'N/A';
  setTimeout(() => {
    if (planName && typeof planName == 'string') {
      let myAccountLink = document.querySelector('a[href="/myAccount"]');
      if (!myAccountLink) {
        const rootLinks = Array.from(document.querySelectorAll('a[href="/"]')) || [];
        myAccountLink = rootLinks.find(a => a.textContent && a.textContent.includes('My Account'));
      }
    }
  }, 1000);
}

// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = obj => Object.keys(obj).length === 0

// ** Returns K format from a number
export const kFormatter = num => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num)

// ** Converts HTML to string
export const htmlToString = html => html ? html.replace(/<\/?[^>]+(>|$)/g, '') : ''

// ** Checks if the passed date is today
const isToday = date => {
  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}

// ** Toast Component
const ToastComponent = ({ title, icon, color }) => (
  <Fragment>
    <div className='toastify-header pb-0'>
      <div className='title-wrapper'>
        <Avatar size='sm' color={color} icon={icon} />
        <h6 className='toast-title'>{title}</h6>
      </div>
    </div>
  </Fragment>
)

// ** apiCall error limit and counter
let globalErrorLimit = 1;
let counter = 0

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (value, formatting = { month: 'short', day: 'numeric', year: 'numeric' }) => {
  if (!value) return value
  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value)
  let formatting = { month: 'short', day: 'numeric' }

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' }
  }

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => localStorage.getItem('userToken')
export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = UserInfo => {
  if (UserInfo.ability && UserInfo.ability.defaultRoute) {
    localStorage.setItem('DefaultRoute', UserInfo.ability.defaultRoute)
    return UserInfo.ability.defaultRoute
  } else if ( UserInfo.accessLevel && UserInfo.accessLevel <= 3 ) {
    localStorage.setItem('DefaultRoute', '/analytics')
    return '/analytics'
  } else if (UserInfo.accessLevel && UserInfo.accessLevel == 4) {
    localStorage.setItem('DefaultRoute', '/leadBoard')
    return '/leadBoard'
  } else {
    return REACT_APP_LOGIN_PAGE
  }
}

// ** React Select Theme Colors
export const selectThemeColors = theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: '#1868db1a', // for option hover bg-color
    primary: '#1868db', // for selected option bg-color
    neutral10: '#1868db', // for tags bg-color
    neutral20: '#ededed', // for input border-color
    neutral30: '#ededed' // for input hover border-color
  }
})

export const envVariables = () => {
  let env = process.env;
  let envVariables = {};

  if (process.env.envVariables) {
    return envVariables;
  }

  Object.keys(env).forEach( variable => {
      let keys = variable.split('_');
      if ( `${keys[0]}_${keys[1]}` == 'REACT_APP' ){
          if (variable == 'REACT_APP_API_URL'){
              envVariables[variable] = env[variable];
          } else {
              envVariables[variable] = env['REACT_APP_API_URL'] + env[variable];
          }
      } else {
          envVariables[variable] = env[variable];
      }
  })
  
  return envVariables;
}

export const apiCall = async (envUrl, type, body = {}, contentType = "application/json", extraHeaders = {}, showToast = true) => {
  try {
    if (!type || !envUrl){
      return false
    }

    if (contentType === null) {
      contentType = "application/json"
    }
    if (extraHeaders === null) {
      extraHeaders = {}
    }

    const config = {
      url : envVariables()[envUrl],
      method : type,
      headers: {
        "Content-Type": contentType,
        ...extraHeaders
      },
      data : body,
    };
    const {data} = await axios(config);
    if (!data){
      return false
    }
    return data;
  } catch (error) {
    try {

      // counter && limit to avoid toast spamming
      let {data} = error && error.response || {};
      if (data && data.result && counter <= globalErrorLimit){
        counter++
        let result = data.result || {}
        if ( result.msg == "PARAMETER_ISSUE" ){
          let err = result.err || {};
          let list = Object.values(err.list) || [];
          for (let i = 0; i < ((list.length > 3)?3:list.length); i++) {
            const element = list[i];
            if (showToast){
              toast.error(<ToastComponent title={element.message} color='danger' icon={<X />} />, {
                autoClose: 2000,
                hideProgressBar: true,
                closeButton: false
              })
            }
          }
        } else {
          if (showToast){
            // toast.error(result.msg);
            toast.error(<ToastComponent title={result.msg} color='danger' icon={<X />} />, {
              autoClose: 2000,
              hideProgressBar: true,
              closeButton: false
            })
          }
        }
        setTimeout(() => {
          counter = 1
        }, 4000);
      }
      return data;
    } catch (error) { console.log('apiCall Toast Error ::', error); }
    console.log('[Utils.js]::apiCall::Error::', typeof(error), error);
    if (showToast) {
      let msg = "Error";
      if ( error.response && error.response.data && error.response.data.result && error.response.data.result.msg) {
        msg = error.response.data.result.msg;
      }
      toast.error(<ToastComponent title={msg} color='danger' icon={<X />} />, {
        autoClose: 2000,
        hideProgressBar: true,
        closeButton: false
      })
    }
    return (error.response)?error.response.data:false;
  }
}

export const apiCallBlob = async (envUrl, type, body = {}, extraHeaders = {}, showToast = true) => {
  try {
    if (!type || !envUrl){
      return false
    }

    const config = {
      url : envVariables()[envUrl],
      method : type,
      headers: {
        ...extraHeaders
      },
      data : body,
      responseType: 'blob'
    };
    const response = await axios(config);
    if (!response || !response.data){
      return false
    }
    return response.data;
  } catch (error) {
    if (showToast) {
       toast.error(<ToastComponent title="Download Failed" color='danger' icon={<X />} />, {
        autoClose: 2000,
        hideProgressBar: true,
        closeButton: false
      })
    }
    console.log('[Utils.js]::apiCallBlob::Error::', typeof(error), error);
    return false;
  }
}

// ** Toast Component
export const toastify = (
  type="success",
  title="untitled",
  color="success",
  icon=false,
  autoClose=2000,
  hideProgressBar=true,
  closeButton=false
  ) => {

  icon = (!icon && type && type === 'error') ? <X/> : (!icon) ? <Check/> : icon;

  const ToastComponent = ({title, color, icon}) => (
    <Fragment>
      <div className='toastify-header pb-0'>
        <div className='title-wrapper'>
          <Avatar size='sm' color={color} icon={icon} />
          <h6 className='toast-title'>{title}</h6>
        </div>
      </div>
    </Fragment>
  )

  toast[type](<ToastComponent title={title} color={color} icon={icon} />, {
    autoClose,
    hideProgressBar,
    closeButton
  })

}

export const getNextImmidiateMinEpoch = (options = {}) => {
  try {
    const {epochInSec = Math.floor(Date.now() / 1000), nextImmediateMin = 5} = options;
    const remainder = epochInSec % (nextImmediateMin * 60); // Convert minutes to seconds
    const diffSeconds = remainder === 0 ? 0 : (nextImmediateMin * 60) - remainder;
    return epochInSec + diffSeconds;
  } catch (error) {
    console.log({
      type: 'error', fileName:"Utils.js", functionName: 'getNextImmidiateSecEpoch',
      log: 'ERROR_IN_getNextImmidiateSecEpoch',
      error,
    });
    return false;
  }
}

export const getStandaredDateTime = ( value = null, format = "YYYY-MM-DD HH:mm:ss SSS" ) => {
  if(value){
    return moment(value, format).format('YYYY-MM-DD HH:mm:ss SSS');
  } else {
    return moment().format('YYYY-MM-DD HH:mm:ss SSS');
  }
}

// ** Returns short month of passed date
export const formattedDateTime = (value, format = "YYYY-MM-DD HH:mm:ss SSS") => {
  // const date = new Date(value)
  
  if (!value) {
    return value;
  }

  // if (!moment(value).isValid()) {
    value = moment(value, format)
  // }

  if (moment(value).isSame(moment(), 'day')) {
    return "Today " + moment(value).format('h:mm A');
  } else if (moment(value).isSame(moment().subtract(1, "day"), 'day')) {
    return "Yesterday " + moment(value).format('h:mm A');
  } else {
    return moment(value).format('MMM DD h:mm A')
  }
}

export const getDefaultLeadStatusArray = () => {
  let defaultLeadStatusArray = getLeadStatusArrayFromLocal();
  if (defaultLeadStatusArray.length <= 0) {
    defaultLeadStatusArray = [
      {value : 'open'        , label : 'Open'        ,icon : Users       , pillColor : 'light-primary'   , isFixed : 'true'  , rank : 1 },
      {value : 'reOpen'      , label : 'Re-Open'     ,icon : RefreshCw   , pillColor : 'light-info'      , isFixed : 'false'  , rank : 2 },
      {value : 'contacted'   , label : 'Contacted'   ,icon : PhoneCall   , pillColor : 'light-success'   , isFixed : 'false' , rank : 3 },
      {value : 'progress'    , label : 'Progress'    ,icon : FastForward , pillColor : 'light-warning'   , isFixed : 'false' , rank : 4 },
      {value : 'qualified'   , label : 'Qualified'   ,icon : ThumbsUp    , pillColor : 'light-success'   , isFixed : 'false' , rank : 5 },
      {value : 'unQualified' , label : 'Un-Qualified' ,icon : ThumbsDown  , pillColor : 'light-danger'    , isFixed : 'false' , rank : 6 },
      {value : 'hold'        , label : 'Hold'        ,icon : PauseCircle , pillColor : 'light-warning'   , isFixed : 'false' , rank : 7 },
      {value : 'closed'      , label : 'Closed'      ,icon : UserCheck   , pillColor : 'light-secondary' , isFixed : 'false'  , rank : 8 },
    ]
  }
  return defaultLeadStatusArray;
}
export const getLeadStatusArrayFromLocal = () => {
  let localLeadStatusArray = window.localStorage.getItem('leadStatusArray');
  const lastFetched = window.localStorage.getItem('leadStatusArrayLastFetched');
  
  if (localLeadStatusArray && lastFetched) {
    const now = new Date().getTime();
    const oneDay = 24 * 60 * 60 * 1000;
    if (now - parseInt(lastFetched) > oneDay) {
      return []; // Expired
    }
  } else if (localLeadStatusArray && !lastFetched) {
    return []; // Force refresh if no timestamp found
  }

  if (typeof localLeadStatusArray === 'string' && localLeadStatusArray.length > 0) {
    try {
      localLeadStatusArray = JSON.parse(localLeadStatusArray);
    } catch (e) {
      localLeadStatusArray = [];
    }
  } else {
    localLeadStatusArray = [];
  }
  return localLeadStatusArray;
}
export const setLeadStatusArrayToLocal = (value) => {
  window.localStorage.setItem('leadStatusArrayLastFetched', new Date().getTime().toString());
  return window.localStorage.setItem('leadStatusArray', value);
}
export const clearLeadStatusArrayFromLocal = () => {
  window.localStorage.removeItem('leadStatusArrayLastFetched');
  return window.localStorage.removeItem('leadStatusArray');
}
export const getLeadStatusArray = async () => {
  let leadStatusArray = getLeadStatusArrayFromLocal()
  if (leadStatusArray.length <= 0) {
    const {result} = await apiCall('REACT_APP_GET_LEAD_STATUS', "POST", {}, null, null, false);
    if (result && result['success'] && result['status']) {
      setLeadStatusArrayToLocal(JSON.stringify(result['status']));
      leadStatusArray = result['status'];
    } else {
      console.error('[Utils]::something went wrong while fetching leadStatusArray::', result);
      leadStatusArray = getDefaultLeadStatusArray();
    }
  }
  for (let index = 0; index < leadStatusArray.length; index++) {
    const {icon} = leadStatusArray[index];
    if (icon) {
      leadStatusArray[index].icon = ReactFeatherIcon[icon];
    }
  }
  return leadStatusArray;
}
export const customStatusArray = [
  {value : 'isImportant', label : 'Important',icon : Star, pillColor : 'light-primary', isFixed : 'true', rank : 1},
  {value : 'hasCallback', label : 'Callbacks',icon : PhoneIncoming, pillColor : 'light-primary', isFixed : 'true', rank : 2}
]

export const phoneNumberFormatting = (phoneNumber = '') => {
  if (!phoneNumber.length || phoneNumber.length < 10) {
    return phoneNumber
  }

  let pArray = phoneNumber.split('');

  for (let index = pArray.length; index >= 0; index--) {
    if (index === pArray.length - 5 || index === pArray.length - 10 || index === pArray.length - 15) {
      pArray[index] = " " + pArray[index]
    }
  }



  // return phoneNumber.split('').reverse().map((n,i) => (i % 5 === 0 && i !== 0) ? ` ${n}` : n).reverse().join('');

  // if (phoneNumber.length === 10) {
  //   return `${phoneNumber.substring(0,5)} ${phoneNumber.substring(5,10)}`
  // } else if(phoneNumber.length === 11) {
  //   return `${phoneNumber.substring(0,6)} ${phoneNumber.substring(6,11)}`
  // } else if(phoneNumber.length === 12) {
  //   return `${phoneNumber.substring(0,2)} ${phoneNumber.substring(2,7)} ${phoneNumber.substring(7,12)}`
  // } else if(phoneNumber.length === 13 && phoneNumber[0] === '+') {
  //   return `${phoneNumber.substring(0,3)} ${phoneNumber.substring(3,8)} ${phoneNumber.substring(8,13)}`
  // }  else {
  // }

  // let pArray = phoneNumber.split('');

  // if (phoneNumber.length )

  // if ([10, 11, 12, 13].indexOf(phoneNumber.length) !== -1) {

  //     for (let index = pArray.length; index >= 0; index--) {
  //       if (index === pArray.length - 5) {
  //         pArray[index] = " " + pArray[index]
  //       } else if (index === pArray.length - 10 && phoneNumber.substring(index - 2,index - 1) === '91') {
  //         pArray[index] = " " + pArray[index]
  //       }
  //     }

  // } else {
  //   let firstCounter = false
  //   let counter = 1;
  //   for (let index = pArray.length; index >= 0; index--) {
  //     if (!firstCounter && index === pArray.length - 4) {
  //       pArray[index] = "-" + pArray[index]
  //       firstCounter = true
  //     } else if (firstCounter) {
  //       counter++
  //       if (counter >= 4) {
  //         counter = 1
  //         pArray[index] = "-" + pArray[index]
  //       }
  //     }
  //   }
  // }

  return pArray.join('')
}

export const badgeColorForDateTime = (value, format = "YYYY-MM-DD HH:mm:ss SSS") => {
  // const date = new Date(value)

  if (!value || (value.contains && value.contains('--'))) {
    return 'secondary'
  }
  
  // if (!moment(value).isValid()) {
    value = moment(value, format)
  // }

  if (moment(value).isSame(moment(), 'day')) { // today
    return "success";
  } else if (moment(value).isSame(moment().subtract(1, "day"), 'day')) {  // yesterday
    return "warning"
  }

  /** possible scenario
   * 1. future (> today)
   * 2. past (< yesterday)
   */

  let valueEpoch = parseInt(moment(value).format('X'));
  let currentEpoch = parseInt(moment().format('X'));

  if (valueEpoch > currentEpoch) { // future
    return 'primary'
  } else {
    return 'danger'
  }

}

export const ReactFeatherLink = Link;

export const Whatsapp = (props = {}) => {
  const {size = 16, color} = props
  if (color === 'success') {
    return (
      <img src={whatsappGreen} alt='whatsapp' height={size} width={size} />
    )    
  }
  if (color === 'primary') {
    return (
      <img src={whatsappPrimary} alt='whatsapp' height={size} width={size} />
    )    
  }
  return (
    <img src={whatsappWhite} alt='whatsapp' height={size} width={size} />
  )
}

export const textWrap = (string, allowedLength = 20) => {

  if (!string) {
    return string;
  }

  string = string.toString();
  allowedLength = parseInt(allowedLength);

  if (string.length <= allowedLength) {
    return string
  }

  return string.substring(0, allowedLength) + " " + string.substring(allowedLength, string.length)
}

export const handleMessageFromParent = async (event = {}, sys = {}) => {

  const { type, data = {}, subType, leadData, messageId, native_auth_token } = event.data || {};
  const {history} = sys || {};

  if (type && window.localStorage.getItem('PLATFORM') === 'MOBILE' && (!native_auth_token || native_auth_token !== process.env.REACT_APP_NATIVE_EVENT_TOKEN)) {
    toastify('error', "native communication token is invalid or not found", 'danger', <X/>);
    return;
  }

  switch (type) {
    case 'setMobilePlatform':
      window.localStorage.setItem('platform', "MOBILE");
      window.localStorage.setItem('os', data.os || '');
      window.localStorage.setItem('osVersion', data.osVersion || '');
      window.localStorage.setItem('appVersion', data.appVersion || '');
      window.localStorage.setItem('appBuildNumber', data.appBuildNumber || '');
      window.localStorage.setItem('deviceBrand', data.deviceBrand || '');
      window.localStorage.setItem('deviceName', data.deviceName || '');
      window.localStorage.setItem('appLastUpdateStamp', data.appLastUpdateStamp || '');
      break;

    case 'GET_THEME':
      event.data.type = "THEME_TOGGLE"
      let skin = window.localStorage.getItem('skin');
      try {
        skin = skin ? JSON.parse(skin) : themeConfig.layout.skin;
      } catch (error) {
        skin = themeConfig && themeConfig.layout && themeConfig.layout.skin || 'light';
      }
      event.data.data = {"skin": skin};
      sendMessageToParent(event.data)
      break;

    case 'getBackPressAction':
      sendMessageToParent(event.data)
      break;

    case 'COMMUNICATION':
      if (leadData && leadData._id) {
        const body = {
          leadId : leadData._id,
          interactionType : 'communication',
        }


        switch (subType) {
          case 'PHONE_CALL':
            body['interactionMode'] = 'call';
            await apiCall('REACT_APP_UPDATE_INTERACTION_INFO', "POST", body, null, null, false);
            window.location.reload(false);
            break;
          case 'TXT_MESSAGE':
            body['interactionMode'] = 'message';
            await apiCall('REACT_APP_UPDATE_INTERACTION_INFO', "POST", body, null, null, false);
            break;
          case 'WHATSAPP_MESSAGE':
            body['interactionMode'] = 'whatsapp';
            await apiCall('REACT_APP_UPDATE_INTERACTION_INFO', "POST", body, null, null, false);
            break;
        
          default:
            console.log('[Utils]::handleMessageFromParent::SUB_TYPE_NOT_FOUND::', event.data);
            break;
        }
      }
      break;
  
    case 'PUSH_NOTIFICATION_TOKEN':
      if (event.data && event.data.pushNotificationToken) {
        window.localStorage.setItem('pushNotificationToken', event.data.pushNotificationToken);
        const body = {
          token : event.data.pushNotificationToken,
          platform : window.localStorage.getItem('platform'),
          os: window.localStorage.getItem('os'),
          osVersion: window.localStorage.getItem('osVersion'),
          appVersion: window.localStorage.getItem('appVersion'),
          appBuildNumber: window.localStorage.getItem('appBuildNumber'),
          deviceBrand: window.localStorage.getItem('deviceBrand'),
          deviceName: window.localStorage.getItem('deviceName'),
          appLastUpdateStamp: window.localStorage.getItem('appLastUpdateStamp'),
          browserName: window.localStorage.getItem('browserName'),
          browserVersion: window.localStorage.getItem('browserVersion')
        }
        const {result} = await apiCall('REACT_APP_UPDATE_PUSH_NOTIFICATION_TOKEN', "POST", body, null, null, false) || {};
        event.data.type = "PUSH_NOTIFICATION_TOKEN_SEND_SUCCESS"
        sendMessageToParent(event.data)

        // send update status if any
        if (result && result['status'] && result['status']['versionFlags']) {
          const {update_available, force_upgrade_app} = result['status']['versionFlags'] || {};
          if (force_upgrade_app) {
            sendMessageToParent({type:"FORCE_UPGRADE_APP"});
          } else if (update_available) {
            sendMessageToParent({type:"UPDATE_AVAILABLE"});
          }
        }
      } else {
        console.error('[Utils]::pushNotificationToken not found in event::', event.data);
      }
      break;

    case 'PUSH_NOTIFICATION_CLICKED':

      event.data.type = "PUSH_NOTIFICATION_CLICKED_ACK"
      sendMessageToParent(event.data);

      if (data && data['nType'] && data['uniqueId'] && data['userName']) {

        // mark as read
        await apiCall('REACT_APP_UPDATE_PUSH_NOTIFICATION', "POST", { messageId : messageId, isRead : true }, null, null, false);

        // perform action on click

        switch (data['nType']) {
          case 'leadAssigned':
          case 'leadCallback':
            redirectToViewLead(data['uniqueId']);
            break;
          case 'whatsappMessage':
            redirectToViewLead(data['uniqueId'], undefined, {vlt: 'chat'});
            break;
          case 'leadAssignedNotify':
          case 'openLeadReminder':
          case 'todaysLeadSummary':
            break;
          case 'unreadNotificationReminder':
            handleNotificationDropDown('open');
            break;
        
          default:
            console.error('[Utils]::nType not defined::', event.data);
            break;
        }

      } else {
        console.error('[Utils]::data not found in event::', event.data);
      }
      break;

    case 'SET_DEEP_LINK_URL':
      event.data.type = "SET_DEEP_LINK_URL_ACK"
      const parsedUrl = data && data['deepLinkUrl'] && URL.parse(data['deepLinkUrl']);
      if (parsedUrl) {
        sendMessageToParent(event.data);
        if (history && history.push) {
          history.push({
            pathname: parsedUrl.pathname,
            search: parsedUrl.search
          });
        } else {
          window.location.href = `${parsedUrl.pathname || '/'}${parsedUrl.search || ''}`;
        }
      }
      break;

    default:
      break;
  }

}

export const sendMessageToParent = (data = {}) => {

  if (!window.ReactNativeWebView || typeof window.ReactNativeWebView.postMessage !== 'function') {
    return;
  }

  if (!data.type) {
    console.log('[Utils]::type is required::');
    return;
  }

  data['native_auth_token'] = process.env.REACT_APP_NATIVE_EVENT_TOKEN;

  window.ReactNativeWebView.postMessage(JSON.stringify(data));

}

/**
 * Returns true if the given epoch is before the current time or before a specified threshold.
 *
 * @param epoch - Unix timestamp (in seconds)
 * @param offsetUnit - Optional Moment.js unit ('day', 'week', 'month', etc.)
 * @param offsetCount - Optional number of units to subtract from now
 */
export const epochIsBefore = (epoch = "", offsetUnit, offsetCount = 0) => {
  try {
    const baseTime = offsetUnit ? moment().subtract(offsetCount, offsetUnit) : moment();
    return moment(Number(epoch), "X").isBefore(baseTime);
  } catch (error) {
    console.log('[Utils]:epochIsBefore:error::', typeof error, error);
    return false;
  }
}

export const csvToJson = async (file) => {
  const data = await new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsText(file.data);
    reader.onload = (e) => {
      const buffer = e.target.result;
      Papa.parse(buffer, {
        header: true,
        skipEmptyLines: true,
        complete: function (results) {
          resolve(results.data)
        },
      });
    }
  })
  return {
    file,
    data
  }
}

export function convertArrayOfObjectsToCSV(data) {
  if (!data || !data.length) {
    return null; // Return null if data is empty or undefined
  }

  const headers = Object.keys(data[0]); // Extract headers from the first object
  const csvRows = [];

  // Add headers row
  csvRows.push(headers.join(',')); // Join headers with commas

  // Add rows for each object
  data.forEach((row) => {
    const values = headers.map((header) => {
      const value = row[header];
      if (header === "phoneNumber" || header === "alternateNumber") {
        return `"P:${value}"`;
      }
      return typeof value === 'string' ? `"${value.replace(/"/g, '""')}"` : value;
    });
    csvRows.push(values.join(','));
  });

  // Combine rows into a single string, separated by new lines
  return csvRows.join('\n');
}


export function downloadCSV(array, csvName) {
  const csv = convertArrayOfObjectsToCSV(array)
  if (!csv) return

  const BOM = '\uFEFF' // UTF-8 BOM for Excel compatibility
  const blob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.setAttribute('href', url)
  link.setAttribute('download', csvName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  URL.revokeObjectURL(url)
}

export function downloadExcel(array, fileName = 'export') {
  if (!array || !array.length) return;

  const formattedData = array.map((row) => {
    const newRow = {};
    Object.keys(row).forEach((key) => {
      newRow[key] = row[key];
    });
    return newRow;
  });
  const ws = XLSX.utils.json_to_sheet(formattedData);
  const headers = Object.keys(array[0]);
  ws['!cols'] = headers.map((header) => {
    const maxLen = Math.max(
      header.length,
      ...array.map((row) => String(row[header] ?? '').length)
    );
    return { wch: Math.min(maxLen + 2, 50) }; // cap at 50 chars
  });

  headers.forEach((_, colIndex) => {
    const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIndex });
    if (!ws[cellAddress]) return;
    ws[cellAddress].s = {
      font: { bold: true, color: { rgb: '#FFFFFF' } },
      fill: { fgColor: { rgb: '#1868DB' } },
      alignment: { horizontal: 'center' },
    };
  });
  array.forEach((_, rowIndex) => {
    headers.forEach((header, colIndex) => {
      if (header === 'phoneNumber' || header === 'alternateNumber') {
        const cellAddress = XLSX.utils.encode_cell({ r: rowIndex + 1, c: colIndex });
        if (ws[cellAddress]) {
          ws[cellAddress].z = '@';
        }
      }
    });
  });

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Leads');
  XLSX.writeFile(wb, `${fileName}.xlsx`);
}



export function getTenantByHost(host) {
  if (host && host.includes(REACT_APP_UI_DOMAIN)) {
    return host.split(`.${REACT_APP_UI_DOMAIN}`)[0] || ''
  } else {
    return '';
  }
}

export const REACT_APP_LOGIN_PAGE = process.env.REACT_APP_LOGIN_PAGE || '/login-v1';
export const REACT_APP_SIGNUP_PAGE = process.env.REACT_APP_SIGNUP_PAGE || '/register-v1';

export const redirectToViewLead = (leadId, history, options = {}) => {
  if (!leadId) {
    console.error('[Utils]::redirectToViewLead leadId not found', leadId);
    return;
  }

  let status = 'open';
  let skip = '0';
  let vlt = 'timeline'

  try {
    if (window.location && window.location.pathname && window.location.pathname.includes('/leadBoard/')) {
      const [_, _route = 'leadBoard', _status = 'open', _skip = '0', _operationType, _leadId] = window.location.pathname.split('/');
      if (_operationType && _operationType === 'viewLead') {
        if (leadId === _leadId) {
          console.log('[Utils]::redirectToViewLead on same page', leadId);
          return;
        }
        const { _vlt = 'timeline' } = queryString.parse(window.location.search);
        vlt = _vlt;
      }
      status = _status;
      skip = _skip;
    }

    if (options && options.vlt) {
      vlt = options.vlt;
    }

    const path = `/leadBoard/${status}/${skip}/viewLead/${leadId}?vlt=${vlt}`;
  
    if (history && typeof history.push === 'function') {
      history.push(path);
    } else {
      window.location.href = path;
    }
  } catch (error) {
    console.error('[Utils]::redirectToViewLead Error', error);
  }
}

export const handleNotificationDropDown = (nextState = 'open') => {

  if (!['open', 'close'].includes(nextState)) {
    console.error('[Utils]::handleNotificationDropDown invalid next state', nextState);
    return;
  }
  try {
    const dropdownElement = document.getElementsByClassName('dropdown-notification')[0];
    if (!dropdownElement) {
      console.error('[Utils]::handleNotificationDropDown element not found', dropdownElement);
      return;
    }

    let isOpen = dropdownElement.classList.contains('show');
    
    if ((isOpen && nextState === 'close') || (!isOpen && nextState === 'open')) {
      dropdownElement.children[0].click();
    } else {
      console.log('[Utils]::handleNotificationDropDown already on same state', {isOpen, nextState});
    }

  } catch (error) {
    console.error('[Utils]::handleNotificationDropDown Error', error);
  }
}

export const getBrowserInfo = () => {
  const parser = new UAParser();
  const result = parser.getResult() || {};

  return {
    os: result.os && result.os.name || 'Unknown',
    osVersion: result.os && result.os.version || '',
    browserName: result.browser && result.browser.name || 'Unknown',
    browserVersion: result.browser && result.browser.version || '',
    deviceBrand: result.device && result.device.vendor || '',
    deviceName: result.device && result.device.model || '',
  };
}

export const daysDiff = (date1, date2, date1Format = 'YYYY-MM-DD HH:mm:ss SSS', date2Format = 'YYYY-MM-DD HH:mm:ss SSS') => {
  return moment(date2, date1Format).diff(moment(date1, date2Format), 'days');
}

export const urlPush = (url, replaceState = false, history) => {
  if (replaceState) {
    return window.history && window.history.replaceState && window.history.replaceState(null, '', url);
  }
  history && typeof history.push === 'function' && history.push(url);
}

export const getAppInitInfo = () => {
  try {
    const { appinit } = queryString.parse(window.location.search);
    if (appinit) {
      const decodedData = atob(appinit);
      return JSON.parse(decodedData);
    }
  } catch (error) {
    console.error('[Utils]::getAppInitInfo::error::', error);
  }
  return null;
}

export const isIOSMobileApp = () => {
  return window.localStorage.getItem('platform') === 'MOBILE' && window.localStorage.getItem('os') === 'ios';
}

export const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = (error) => {
      toastify('error', `Razorpay Script Error: ${error && error.message}`, 'danger', <X/>)
      resolve(false)
    };
    const element = document.getElementById('razorpay-magic-checkout') || document.body;
    element.appendChild(script);
  });
}


export const getRoleByAccessLevel = (accessLevel = '') => {
  const roleObj = {
    "4": 'agent',
    "3": 'supervisor',
    "2": 'admin',
    "1": 'godFather'
  }
  return accessLevel && roleObj[String(accessLevel)] || '';
}

/**
 * Automatically retries and reloads page when a lazy-loaded chunk fails
 * Essential for mobile app iframe/WebView sessions after a deployment
 */
export const lazyRetry = (componentImport) =>
  new Promise((resolve, reject) => {
    const hasRefreshed = JSON.parse(
      window.sessionStorage.getItem('retry-lazy-refreshed') || 'false'
    );

    componentImport()
      .then((component) => {
        window.sessionStorage.setItem('retry-lazy-refreshed', 'false');
        resolve(component);
      })
      .catch((error) => {
        if (!hasRefreshed) {
          window.sessionStorage.setItem('retry-lazy-refreshed', 'true');
          window.location.reload();
        } else {
          reject(error);
        }
      });
  });